import React, { ReactElement } from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";

interface QNLISamplesProps {
  sampleSelectedCallback?: (question: string, context: string) => void;
}

const Samples = (props: QNLISamplesProps): ReactElement => {
  const { sampleSelectedCallback } = props;

  const getLabelText = (label: string): string => {
    return label === "LABEL_0" ? "Entails" : "Does not entail";
  };

  const SAMPLES: { question: string; context: string; label: string }[] = [
    { question: "Quando será lançado o novo smartphone?", context: "A empresa anunciou que vai lançar um novo modelo de smartphone na próxima semana.", label: "LABEL_0" },
    { question: "O que causou o congestionamento na ponte?", context: "O trânsito na ponte ficou congestionado devido ao acidente matinal.", label: "LABEL_0" },
    { question: "Quem venceu a maratona?", context: "O atleta terminou a maratona em duas horas e dez minutos.", label: "LABEL_1" },
    { question: "Qual será a temperatura amanhã?", context: "As previsões meteorológicas indicam chuva forte para amanhã.", label: "LABEL_1" },
    { question: "A nova legislação foi aprovada?", context: "O projeto de lei foi aprovado pelo parlamento e entrará em vigor em breve.", label: "LABEL_0" },
  ];

  return (
    <>
      {SAMPLES.map((sample, index) => {
        return (
          <Paper
            key={"sample-" + index}
            variant="elevation"
            elevation={4}
            sx={{
              padding: "8px",
              marginBottom: "10px",
              border: "1px solid",
              borderColor: "primary.light",
              backgroundColor: "background.paper",
              cursor: "pointer",
              transition: "box-shadow 0.2s ease, transform 0.2s ease",
              "&:hover": {
                boxShadow: 6,
                transform: "translateY(-2px)",
              },
            }}
            onClick={() => {
              sampleSelectedCallback &&
                sampleSelectedCallback(sample.question, sample.context);
            }}
          >
            <Stack spacing={1.5}>
              <Chip
                label={sample.label + " · " + getLabelText(sample.label)}
                color={sample.label === "LABEL_0" ? "success" : "default"}
                variant={sample.label === "LABEL_0" ? "filled" : "outlined"}
                size="small"
                sx={{ alignSelf: "flex-start", fontWeight: 700 }}
              />
              <Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Question
                </Typography>
                <Typography variant="body2">{sample.question}</Typography>
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Context
                </Typography>
                <Typography variant="body2">{sample.context}</Typography>
              </Box>
            </Stack>
          </Paper>
        );
      })}
    </>
  );
};

export default Samples;
